import { defineMessages } from 'react-intl';

export default defineMessages({
    printConfirmation: {
        id: 'ml.cancellation.common.views.cancellation-confirmation.Print Confirmation',
        defaultMessage: 'Print Confirmation'
    },
    goToAccount: {
        id: 'ml.cancellation.common.views.ml-cancellation-confirmation.Go To Account',
        defaultMessage: 'Go To Account'
    },
    cancel: {
        id: 'ml.cancellation.common.views.cancellation-confirmation.Cancel',
        defaultMessage: 'Cancel'
    },
    policyCancelled: {
        id: 'ml.cancellation.common.views.cancellation-confirmation.Policy Cancelled',
        defaultMessage: 'This {policyType} policy has been cancelled'
    },
});